export default __webpack_public_path__ + "static/media/asdt_new_logo.42523180.png";